import { MutationTree, ActionTree, GetterTree } from 'vuex'
import {
  getMyTickets,
  getRedemptionGroup,
} from '@/utils/redemption'
import {
  SET_TICKETS,
  SET_TICKETS_TO_EMPTY,
  SET_REDEMPTION_TAB,
  SET_REDEMPTION_GROUP,
  SET_REDEMPTION_GROUP_TO_EMPTY,
  SET_QR_CODE,
  SET_ALL_QR_CODE,
  SET_TICKETS_PAGINATION,
  SET_TICKETS_REDEEMED,
  SET_TICKETS_EXPIRED,
} from '@/store/types'
import { RootState } from '..'

export interface RedemptionObject {
  valid_date: string;
  title: string;
  orderId: string;
  count: number;
  isSelfRedeem: boolean;
  isRedeemAll: boolean;
}

export interface IProperty {
  name: string;
  value: string;
}
export interface ITicketInfo {
  color: string;
  status: string;
}

export interface TicketObject {
  _id: string;
  is_redeemed: boolean;
  isRefund: boolean;
  isVerified: boolean;
  isVerifiedBySingpass: boolean;
  title: string;
  variant: string;
  shopify_item_id: string;
  n4: string;
  notes: string;
  valid_date: string;
  variants: string[];
  redeemed_at?: string;
  properties: IProperty[];
  ticketInfo: ITicketInfo;
  timeslotName: string;
  bookingId: string;
}
export interface QrCodeObject {
  qrcode: string[];
  allQrcode: string[];
}

export interface Pagination {
  first: boolean;
  last: boolean;
  size: number;
  currentPage: number,
  currentPageOfElements: number,
  totalPages: number,
  totalElements: number
}

export interface RedemptionState {
  tickets: RedemptionObject[] | null;
  qrcode: QrCodeObject[] | string;
  allQrcode: QrCodeObject[] | string;
  redemptionsTabIndex: number;
  redemptionGroups: {
    [redemptionGroupId: string]: TicketObject;
  };
  pagination: Pagination | null;
  redeemed: string;
  expired: string;
}

const redemptionState: RedemptionState = {
  tickets: null,
  redemptionsTabIndex: 0,
  redemptionGroups: {},
  qrcode: '',
  allQrcode: '',
  pagination: null,
  redeemed: 'false',
  expired: 'false',
}

const getters: GetterTree<RedemptionState, RootState> = {
  tickets: (state) => state.tickets,
  ticketsPagination: (state) => state.pagination,
  qrcode: (state) => state.qrcode,
  allQrcode: (state) => state.allQrcode,
  redemptionsTabIndex: (state) => state.redemptionsTabIndex,
  getRedemptionGroupById: (state) => (redemptionGroupId: string) =>
    state.redemptionGroups[redemptionGroupId],
}

const mutations: MutationTree<RedemptionState> = {
  [SET_TICKETS](state, tickets) {
    state.tickets = tickets
  },
  [SET_TICKETS_PAGINATION](state, pagination) {
    state.pagination = pagination
  },
  [SET_TICKETS_REDEEMED](state, redeemed) {
    state.redeemed = redeemed
  },
  [SET_TICKETS_EXPIRED](state, expired) {
    state.expired = expired
  },
  [SET_TICKETS_TO_EMPTY](state) {
    state.tickets = null
  },
  [SET_REDEMPTION_TAB](state, tabIndex) {
    state.redemptionsTabIndex = tabIndex
  },
  [SET_REDEMPTION_GROUP](state, { id, redemptionGroup }) {
    state.redemptionGroups = {
      ...state.redemptionGroups,
      [id]: redemptionGroup,
    }
  },
  [SET_REDEMPTION_GROUP_TO_EMPTY](state) {
    state.redemptionGroups = {}
  },
  [SET_QR_CODE](state, qrcode) {
    state.qrcode = qrcode.qrcode
  },
  [SET_ALL_QR_CODE](state, allQrcode) {
    state.allQrcode = allQrcode.qrcode
  },
}

const actions: ActionTree<RedemptionState, RootState> = {
  async loadMyTickets(
    { commit, state },
    query: {
      redeemed?: string;
      expired?: string;
      page?: number;
    }
  ) {

    if (state.redeemed !== query.redeemed || state.expired !== query.expired || query.page === 1) {
      commit(SET_TICKETS_TO_EMPTY)
      const { tickets, pagination } = await getMyTickets({ page: 1, limit: 10, redeemed: 'false', expired: 'false', ...query})
      commit(SET_TICKETS, tickets)
      commit(SET_TICKETS_PAGINATION, pagination)
    } else if (state.tickets && Array.isArray(state.tickets)) {
      const { tickets, pagination } = await getMyTickets({ page: 1, limit: 10, redeemed: 'false', expired: 'false', ...query})
      commit(SET_TICKETS, [...state.tickets, ...tickets])
      commit(SET_TICKETS_PAGINATION, pagination)
    }
    commit(SET_TICKETS_REDEEMED, query.redeemed)
    commit(SET_TICKETS_EXPIRED, query.expired)
  },
  async loadRedemptionGroup({ commit }, data) {
    commit(SET_REDEMPTION_GROUP_TO_EMPTY)
    const redemptionGroup = await getRedemptionGroup(data.id, data.query)
    return commit(SET_REDEMPTION_GROUP, { id: data.id, redemptionGroup })
  },
  async loadGenerateQr({ commit }, qrcode: string[]) {
    return commit(SET_QR_CODE, qrcode )
  },
  async loadGenerateAllQr({ commit }, allQrcode: string[]) {
    return commit(SET_ALL_QR_CODE, allQrcode )
  },
}

export default {
  state: redemptionState,
  getters,
  actions,
  mutations,
}
